import { Button, Flex, Result, Spin } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

const servicesRoutes = [
  {
    path: "/data-catalog",
  },
  {
    path: "/donate-dataset",
  },
  {
    path: "/discover-data",
  },
  {
    path: "/data-stewardship",
  },
  {
    path: "/software-catalog",
  },
  {
    path: "/model-catalog",
  },
];

export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (servicesRoutes.some((route) => route.path === location.pathname)) {
      navigate("/login", { replace: true });
    }
  }, [location.pathname, navigate]);

  if (servicesRoutes.some((route) => route.path === location.pathname))
    return (
      <Flex
        style={{ width: "100%", minHeight: 300 }}
        justify="center"
        align="center"
      >
        <Spin />
      </Flex>
    );

  return (
    <Result
      status="404"
      title="404"
      subTitle={t("notFound.subtitle")}
      extra={
        <Link to="/">
          <Button type="primary">{t("notFound.backHome")}</Button>
        </Link>
      }
    />
  );
}
